import { CANCEL_STUDY } from '@custom/constant';
import { createAsyncThunk } from '@reduxjs/toolkit';

const cancel_teleradiologyApi = createAsyncThunk('cancel_teleradiologyApi', async (body: any) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const url = `${CANCEL_STUDY}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    return Promise.reject(error.message || 'Something went wrong');
  }
});

export default cancel_teleradiologyApi;
